import { Hotspot } from 'hooks/queries/designs/useHotspots'

export type PopoverView = 'main' | 'confirmDeletion'

type BaseHotspotEdit<T extends string, P = {}> = {
  type: T
  hotspot: Hotspot
} & P

export type RemoveEdit = BaseHotspotEdit<'remove'>
export type UpdateEdit = BaseHotspotEdit<'update', { prompt: string }>
export type UpdateImageEdit = BaseHotspotEdit<'update_image', { prompt?: string; imageUrls?: string[] }>
export type ReplaceLogoEdit = BaseHotspotEdit<'replace_logo', { imageUrl: string }>

export type HotspotEdit = RemoveEdit | UpdateEdit | UpdateImageEdit | ReplaceLogoEdit

export const HOTSPOT_OPERATIONS: Record<Hotspot['subject_type'], HotspotEdit['type'][]> = {
  text_box: ['update', 'remove'],
  call_to_action: ['update', 'remove'],
  image: ['update_image', 'remove'],
  logo: ['update_image', 'replace_logo', 'remove'],
}
